// Form controls the client screens share, so the Overview's quick edit and the full form offer the
// same choices.
import React, { useState } from 'react';
import { GENDERS, typeOptionsFor, typeSelectValue } from './clientShared';

// Gender: Female / Male / Non-binary, or 'Prefer to self-describe', which reveals a text field.
// A stored value that isn't one of the options shows as a self-description, unchanged.
export function GenderSelect({ id, value, onChange, className = 'input-field' }) {
  const stored = String(value || '').trim();
  const preset = GENDERS.find((g) => g.toLowerCase() === stored.toLowerCase());
  const [selfDescribe, setSelfDescribe] = useState(false);
  // A value filled in later (by AI, say) that isn't an option also shows as a self-description.
  const showSelf = selfDescribe || (!!stored && !preset);
  const choice = showSelf ? 'self' : (preset || '');
  return (
    <div className="space-y-2">
      <select id={id} className={className} value={choice}
        onChange={(e) => {
          const v = e.target.value;
          if (v === 'self') { setSelfDescribe(true); onChange(preset ? '' : stored); }
          else { setSelfDescribe(false); onChange(v); }
        }}>
        <option value="">Not stated</option>
        {GENDERS.map((g) => <option key={g} value={g}>{g}</option>)}
        <option value="self">Prefer to self-describe</option>
      </select>
      {showSelf && (
        <input className={className} value={stored} onChange={(e) => onChange(e.target.value)}
          placeholder="In their own words" aria-label="Gender, in their own words" />
      )}
    </div>
  );
}

// How the plan is managed. 'ndis_managed' and 'ndia_managed' show as one option; the stored code
// only changes if a different option is picked.
export function ClientTypeSelect({ id, value, onChange, className = 'input-field' }) {
  return (
    <select id={id} className={className} value={typeSelectValue(value)}
      onChange={(e) => onChange(e.target.value)}>
      {typeOptionsFor(value).map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
    </select>
  );
}

export const INVOICE_DELIVERY = [
  { value: 'email', label: 'Email' },
  { value: 'post', label: 'Post' },
  { value: 'portal', label: 'Client portal' },
  { value: 'manual', label: 'Manual (hand delivery)' },
];
export const invoiceDeliveryLabel = (v) => (INVOICE_DELIVERY.find((o) => o.value === v) || {}).label || v || '';

export const STATES = ['NSW', 'VIC', 'QLD', 'WA', 'SA', 'TAS', 'ACT', 'NT'];
